import { gql } from "@apollo/client";

export default gql`
  query GetBillingCode {
    getBillingCode {
      providerNo
      billingCode
      cardValidationEnabled
      eorderEmail
    }
  }
`;
